export const VERSION = {
    current: 'v2.0.0'
};
